/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Stats_Activenow1Inputs */

const he_dashboard_stats_activenow1 = /** @type {(inputs: Dashboard_Stats_Activenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פעילים עכשיו`)
};

const en_dashboard_stats_activenow1 = /** @type {(inputs: Dashboard_Stats_Activenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Now`)
};

/**
* | output |
* | --- |
* | "Active Now" |
*
* @param {Dashboard_Stats_Activenow1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_stats_activenow1 = /** @type {((inputs?: Dashboard_Stats_Activenow1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stats_Activenow1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_stats_activenow1(inputs)
	return en_dashboard_stats_activenow1(inputs)
});
export { dashboard_stats_activenow1 as "dashboard_stats_activeNow" }